{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} and {{ moreCount }} more",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }}, and {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} file",
  "{{ count }} files_other": "{{ count }} files",
  "{{ count }} members_one": "{{ count }} member",
  "{{ count }} members_other": "{{ count }} members",
  "{{ count }} members added_one": "{{ count }} member added",
  "{{ count }} members added_other": "{{ count }} members added",
  "{{ count }} people are typing_one": "{{ count }} person is typing",
  "{{ count }} people are typing_many": "{{ count }} people are typing",
  "{{ count }} people are typing_other": "{{ count }} people are typing",
  "{{ count }} photos_one": "{{ count }} photo",
  "{{ count }} photos_other": "{{ count }} photos",
  "{{ count }} reactions_one": "{{ count }} reaction",
  "{{ count }} reactions_other": "{{ count }} reactions",
  "{{ count }} videos_one": "{{ count }} video",
  "{{ count }} videos_other": "{{ count }} videos",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} and {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }} more",
  "{{ member }} will be able to message you again.": "{{ member }} will be able to message you again.",
  "{{ member }} won't be able to message you anymore.": "{{ member }} won't be able to message you anymore.",
  "{{ memberCount }} members": "{{ memberCount }} members",
  "{{ typing }} are typing": "{{ typing }} are typing",
  "{{ typing }} is typing": "{{ typing }} is typing",
  "{{ user }} has been muted": "{{ user }} has been muted",
  "{{ user }} has been unmuted": "{{ user }} has been unmuted",
  "{{ user }} is typing...": "{{ user }} is typing...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} and {{ user }} are typing...",
  "{{ users }} and more are typing...": "{{ users }} and more are typing...",
  "{{ watcherCount }} online": "{{ watcherCount }} online",
  "{{count}} new messages_one": "{{count}} new message",
  "{{count}} new messages_other": "{{count}} new messages",
  "{{count}} unread_one": "{{count}} unread",
  "{{count}} unread_other": "{{count}} unread",
  "{{count}} votes_one": "{{count}} vote",
  "{{count}} votes_other": "{{count}} votes",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} more option",
  "+{{count}} more options_other": "+{{count}} more options",
  "🏙 Attachment...": "🏙 Attachment...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} created: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} voted: {{pollOptionText}}",
  "📍Shared location": "📍Shared location",
  "Actions": "Actions",
  "Add": "Add",
  "Add {{ count }} members_one": "Add {{ count }} member",
  "Add {{ count }} members_other": "Add {{ count }} members",
  "Add a comment": "Add a Comment",
  "Add a comment to your poll answer": "Add a comment to your poll answer",
  "Add an option": "Add an Option",
  "Add channel members": "Add channel members",
  "Add members": "Add members",
  "Add reaction": "Add reaction",
  "Admin": "Admin",
  "All results loaded": "All results loaded",
  "Allow access to camera": "Allow access to camera",
  "Allow access to microphone": "Allow access to microphone",
  "Allow comments": "Allow comments",
  "Allow option suggestion": "Allow option suggestion",
  "Allow others to add comments": "Allow Others to Add Comments",
  "Already a member": "Already a member",
  "Also send as a direct message": "Also send as a direct message",
  "Also send in channel": "Also send in channel",
  "Also sent in channel": "Also sent in channel",
  "An error has occurred during recording": "An error has occurred during recording",
  "An error has occurred during the recording processing": "An error has occurred during the recording processing",
  "Anonymous": "Anonymous",
  "Anonymous poll": "Anonymous Poll",
  "Archive": "Archive",
  "Are you sure you want to delete this message?": "Are you sure you want to delete this message?",
  "Are you sure you want to leave this channel?": "Are you sure you want to leave this channel?",
  "aria/Attachment": "Attachment",
  "aria/Attachment Actions": "Attachment Actions",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Audio position {{ elapsed }} of {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Audio position {{ progress }} percent",
  "aria/Block User": "Block User",
  "aria/Bookmark Message": "Bookmark Message",
  "aria/Cancel recording": "Cancel recording",
  "aria/Cancel Reply": "Cancel Reply",
  "aria/Cancel upload": "Cancel upload",
  "aria/Channel Actions": "Channel Actions",
  "aria/Channel details": "Channel details",
  "aria/Channel list": "Channel list",
  "aria/Channel search results": "Channel search results",
  "aria/Chat view tabs": "Chat view tabs",
  "aria/Clear search": "Clear search",
  "aria/Close callout dialog": "Close callout dialog",
  "aria/Close thread": "Close thread",
  "aria/Collapse sidebar": "Collapse sidebar",
  "aria/Command Suggestions": "Command Suggestions",
  "aria/Complete recording": "Complete recording",
  "aria/Copy Message Text": "Copy Message Text",
  "aria/Decrease value": "Decrease value",
  "aria/Delete Message": "Delete Message",
  "aria/Dismiss notification": "Dismiss notification",
  "aria/Download attachment": "Download attachment",
  "aria/Edit Message": "Edit Message",
  "aria/Emoji picker": "Emoji picker",
  "aria/Emoji Suggestions": "Emoji Suggestions",
  "aria/Exit search": "Exit search",
  "aria/Expand sidebar": "Expand sidebar",
  "aria/File input": "File input",
  "aria/File upload": "File upload",
  "aria/Flag Message": "Flag Message",
  "aria/Image failed to load": "Image failed to load",
  "aria/Image input": "Image input",
  "aria/Increase value": "Increase value",
  "aria/Jump to latest message": "Jump to latest message",
  "aria/Jump to quoted message": "Jump to quoted message",
  "aria/Load More Channels": "Load More Channels",
  "aria/Mark Message Unread": "Mark Message Unread",
  "aria/Mark messages as read": "Mark messages as read",
  "aria/Mention Suggestions": "Mention Suggestions",
  "aria/Menu": "Menu",
  "aria/Message Actions": "Message Actions",
  "aria/Message from {{ user }},": "Message from {{ user }},",
  "aria/Message Options": "Message Options",
  "aria/Message,": "Message,",
  "aria/Mute User": "Mute User",
  "aria/Next page": "Next page",
  "aria/Notifications": "Notifications",
  "aria/Open Attachment Selector": "Open Attachment Selector",
  "aria/Open Channel Actions Menu": "Open Channel Actions Menu",
  "aria/Open channel details": "Open channel details",
  "aria/Open image shared by {{ name }}": "Open image shared by {{ name }}",
  "aria/Open Menu": "Open Menu",
  "aria/Open Message Actions Menu": "Open Message Actions Menu",
  "aria/Open Reaction Selector": "Open Reaction Selector",
  "aria/Open Thread": "Open Thread",
  "aria/Open video shared by {{ name }}": "Open video shared by {{ name }}",
  "aria/Pause": "Pause",
  "aria/Pause recording": "Pause recording",
  "aria/Percent complete": "{{percent}} percent complete",
  "aria/Pin Message": "Pin Message",
  "aria/Play": "Play",
  "aria/Previous page": "Previous page",
  "aria/Quote Message": "Quote Message",
  "aria/Reaction list": "Reaction list",
  "aria/Remind Me Message": "Remind Me Message",
  "aria/Remind Me Options": "aria/Remind Me Options",
  "aria/Remove attachment": "Remove attachment",
  "aria/Remove location attachment": "Remove location attachment",
  "aria/Remove option": "Remove option",
  "aria/Remove Reminder": "Remove Reminder",
  "aria/Remove Save For Later": "Remove Save For Later",
  "aria/Resend Message": "Resend Message",
  "aria/Resume recording": "Resume recording",
  "aria/Retry upload": "Retry upload",
  "aria/Review bounced message": "Review bounced message",
  "aria/Search results": "Search results",
  "aria/Search results header filter button for: {{ source }}": "Search results header filter button for: {{ source }}",
  "aria/Seek audio position": "Seek audio position",
  "aria/Select Channel: {{ channelName }}": "Select Channel: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Select Reaction: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Select User Channel: {{ name }}",
  "aria/Send": "Send",
  "aria/Show preview": "Show preview",
  "aria/Start recording audio": "Start recording audio",
  "aria/Stop AI Generation": "Stop AI Generation",
  "aria/Suggestions": "Suggestions",
  "aria/Thread list": "Thread list",
  "aria/Unblock User": "Unblock User",
  "aria/Unmute User": "Unmute User",
  "aria/Unpin Message": "Unpin Message",
  "Ask a question": "Ask a Question",
  "Attach": "Attach",
  "Attach files": "Attach files",
  "Attachment": "Attachment",
  "Attachment upload blocked due to {{reason}}": "Attachment upload blocked due to {{reason}}",
  "Attachment upload failed due to {{reason}}": "Attachment upload failed due to {{reason}}",
  "Back": "Back",
  "ban-command-args": "[@username] [text]",
  "ban-command-description": "Ban a user",
  "Block user": "Block user",
  "Block User": "Block User",
  "Browse channel members": "Browse channel members",
  "Browse pinned messages": "Browse pinned messages",
  "Cancel": "Cancel",
  "Cannot seek in the recording": "Cannot seek in the recording",
  "Changes saved": "Changes saved",
  "Channel archived": "Channel archived",
  "Channel members": "Channel members",
  "Channel Missing": "Channel Missing",
  "Channel muted": "Channel muted",
  "Channel pinned": "Channel pinned",
  "Channel unarchived": "Channel unarchived",
  "Channel unmuted": "Channel unmuted",
  "Channel unpinned": "Channel unpinned",
  "Channels": "Channels",
  "Chat deleted": "Chat deleted",
  "Chats": "Chats",
  "Choose between 2 to 10 options": "Choose Between 2 to 10 Options",
  "Close": "Close",
  "Close dialog": "Close dialog",
  "Close emoji picker": "Close emoji picker",
  "Close prompt: {{ title }}": "Close prompt: {{ title }}",
  "Command not available while editing": "Command not available while editing",
  "Command not available while replying": "Command not available while replying",
  "Commands": "Commands",
  "Commands matching": "Commands matching",
  "Connection failure, reconnecting now...": "Connection failure, reconnecting now...",
  "Contact info": "Contact info",
  "Contact name": "Contact name",
  "Copy Message": "Copy Message",
  "Create": "Create",
  "Create a question, add options, and configure poll settings": "Create a question, add options, and configure poll settings",
  "Create poll": "Create Poll",
  "Current location": "Current location",
  "Delete": "Delete",
  "Delete chat": "Delete chat",
  "Delete for me": "Delete for me",
  "Delete message": "Delete message",
  "Delivered": "Delivered",
  "Direct message": "Direct message",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.",
  "Download All": "Download All",
  "Download Attachment": "Download Attachment",
  "Download attachment {{ name }}": "Download attachment {{ name }}",
  "Drag your files here": "Drag your files here",
  "Drag your files here to add to your post": "Drag your files here to add to your post",
  "Due {{ timeLeft }}": "Due {{ timeLeft }}",
  "Due since {{ dueSince }}": "Due since {{ dueSince }}",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit": "Edit",
  "Edit chat data": "Edit chat data",
  "Edit contact": "Edit contact",
  "Edit group": "Edit group",
  "Edit Message": "Edit Message",
  "Edit message request failed": "Edit message request failed",
  "Edited": "Edited",
  "Emoji matching": "Emoji matching",
  "Empty message...": "Empty message...",
  "End": "End",
  "End poll": "End Poll",
  "End this poll?": "End this Poll?",
  "End vote": "End Vote",
  "Enforce unique vote is enabled": "Enforce unique vote is enabled",
  "Error": "Error",
  "Error adding flag": "Error adding flag",
  "Error adding members": "Error adding members",
  "Error blocking user": "Error blocking user",
  "Error connecting to chat, refresh the page to try again.": "Error connecting to chat, refresh the page to try again.",
  "Error deleting chat": "Error deleting chat",
  "Error deleting message": "Error deleting message",
  "Error fetching reactions": "Error loading reactions",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.",
  "Error muting a user ...": "Error muting a user ...",
  "Error muting channel": "Error muting channel",
  "Error muting user": "Error muting user",
  "Error opening direct message": "Error opening direct message",
  "Error pinning message": "Error pinning message",
  "Error removing members": "Error removing members",
  "Error removing message pin": "Error removing message pin",
  "Error removing user": "Error removing user",
  "Error reproducing the recording": "Error reproducing the recording",
  "Error starting recording": "Error starting recording",
  "Error unblocking user": "Error unblocking user",
  "Error unmuting a user ...": "Error unmuting a user ...",
  "Error unmuting channel": "Error unmuting channel",
  "Error unmuting user": "Error unmuting user",
  "Error uploading attachment": "Error uploading attachment",
  "Error uploading file": "Error uploading file",
  "Error uploading image": "Error uploading image",
  "Error: {{ errorMessage }}": "Error: {{ errorMessage }}",
  "Exit command {{ command }}": "Exit command {{ command }}",
  "Failed to block user": "Failed to block user",
  "Failed to create the poll": "Failed to create the poll",
  "Failed to create the poll due to {{reason}}": "Failed to create the poll due to {{reason}}",
  "Failed to delete the message": "Failed to delete the message",
  "Failed to end the poll": "Failed to end the poll",
  "Failed to end the poll due to {{reason}}": "Failed to end the poll due to {{reason}}",
  "Failed to jump to the first unread message": "Failed to jump to the first unread message",
  "Failed to leave channel": "Failed to leave channel",
  "Failed to load channels": "Failed to load channels",
  "Failed to load more channels": "Failed to load more channels",
  "Failed to mark channel as read": "Failed to mark channel as read",
  "Failed to play the recording": "Failed to play the recording",
  "Failed to retrieve location": "Failed to retrieve location",
  "Failed to save changes": "Failed to save changes",
  "Failed to share location": "Failed to share location",
  "Failed to update channel archive status": "Failed to update channel archive status",
  "Failed to update channel mute status": "Failed to update channel mute status",
  "Failed to update channel pinned status": "Failed to update channel pinned status",
  "File": "File",
  "File is required for upload attachment": "File is required for upload attachment",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "File is too large: {{ size }}, maximum upload size is {{ limit }}",
  "File too large": "File too large",
  "fileCount_one": "File",
  "fileCount_other": "{{ count }} files",
  "Files": "Files",
  "Flag": "Flag",
  "Generating...": "Generating...",
  "giphy-command-args": "[text]",
  "giphy-command-description": "Post a random gif to the channel",
  "Go back": "Go back",
  "Group info": "Group info",
  "Group name": "Group name",
  "Hide who voted": "Hide Who Voted",
  "Image": "Image",
  "imageCount_one": "Image",
  "imageCount_other": "{{ count }} images",
  "Instant commands": "Instant commands",
  "language/af": "Afrikaans",
  "language/am": "Amharic",
  "language/ar": "Arabic",
  "language/az": "Azerbaijani",
  "language/bg": "Bulgarian",
  "language/bn": "Bengali",
  "language/bs": "Bosnian",
  "language/cs": "Czech",
  "language/da": "Danish",
  "language/de": "German",
  "language/el": "Greek",
  "language/en": "English",
  "language/es": "Spanish",
  "language/es-MX": "Spanish (Mexico)",
  "language/et": "Estonian",
  "language/fa": "Persian",
  "language/fa-AF": "Dari",
  "language/fi": "Finnish",
  "language/fr": "French",
  "language/fr-CA": "French (Canada)",
  "language/ha": "Hausa",
  "language/he": "Hebrew",
  "language/hi": "Hindi",
  "language/hr": "Croatian",
  "language/ht": "Haitian Creole",
  "language/hu": "Hungarian",
  "language/id": "Indonesian",
  "language/it": "Italian",
  "language/ja": "Japanese",
  "language/ka": "Georgian",
  "language/ko": "Korean",
  "language/lt": "Lithuanian",
  "language/lv": "Latvian",
  "language/ms": "Malay",
  "language/nl": "Dutch",
  "language/no": "Norwegian",
  "language/pl": "Polish",
  "language/ps": "Pashto",
  "language/pt": "Portuguese",
  "language/ro": "Romanian",
  "language/ru": "Russian",
  "language/sk": "Slovak",
  "language/sl": "Slovenian",
  "language/so": "Somali",
  "language/sq": "Albanian",
  "language/sr": "Serbian",
  "language/sv": "Swedish",
  "language/sw": "Swahili",
  "language/ta": "Tamil",
  "language/th": "Thai",
  "language/tl": "Tagalog",
  "language/tr": "Turkish",
  "language/uk": "Ukrainian",
  "language/ur": "Urdu",
  "language/vi": "Vietnamese",
  "language/zh": "Chinese (Simplified)",
  "language/zh-TW": "Chinese (Traditional)",
  "Last seen {{ timestamp }}": "Last seen {{ timestamp }}",
  "Leave Channel": "Leave Channel",
  "Leave chat": "Leave chat",
  "Left channel": "Left channel",
  "Let others add options": "Let Others Add Options",
  "Limit votes per person": "Limit Votes per Person",
  "Link": "Link",
  "linkCount_one": "Link",
  "linkCount_other": "{{ count }} links",
  "live": "live",
  "Live for {{duration}}": "Live for {{duration}}",
  "Live location": "Live location",
  "Live until {{ timestamp }}": "Live until {{ timestamp }}",
  "Load more": "Load more",
  "Local upload attachment missing local id": "Local upload attachment missing local id",
  "Location": "Location",
  "Location sharing ended": "Location sharing ended",
  "Location: {{ coordinates }}": "Location: {{ coordinates }}",
  "Manage channel": "Manage channel",
  "Manage members": "Manage members",
  "Mark as unread": "Mark as unread",
  "Maximum number of votes (from 2 to 10)": "Maximum number of votes (from 2 to 10)",
  "Maximum votes per person": "Maximum votes per person",
  "Member detail": "Member detail",
  "mention/Channel": "Channel",
  "mention/Channel Description": "Notify everyone in this channel",
  "mention/Here": "Here",
  "mention/Here Description": "Notify every online member in this channel",
  "Menu": "Menu",
  "Message deleted": "Message deleted",
  "Message failed to send": "Message failed to send",
  "Message has been successfully flagged": "Message has been successfully flagged",
  "Message marked as unread": "Message marked as unread",
  "Message pinned": "Message pinned",
  "Message unpinned": "Message unpinned",
  "Message was blocked by moderation policies": "Message was blocked by moderation policies",
  "Messages have been marked unread.": "Messages have been marked unread.",
  "Missing permissions to upload the attachment": "Missing permissions to upload the attachment",
  "Moderator": "Moderator",
  "Multiple votes": "Multiple Votes",
  "Mute": "Mute",
  "Mute chat": "Mute chat",
  "Mute user": "Mute user",
  "mute-command-args": "[@username]",
  "mute-command-description": "Mute a user",
  "network error": "network error",
  "New": "New",
  "New message from {{user}}": "New message from {{user}}",
  "New Messages!": "New Messages!",
  "Next": "Next",
  "Next image": "Next image",
  "No chats here yet…": "No chats here yet…",
  "No conversations yet": "No conversations yet",
  "No files": "No files",
  "No items exist": "No items exist",
  "No member found": "No member found",
  "No messages found": "No messages found",
  "No photos or videos": "No photos or videos",
  "No pinned messages": "No pinned messages",
  "No results found": "No results found",
  "No user found": "No user found",
  "Nobody will be able to vote in this poll anymore.": "Nobody will be able to vote in this poll anymore.",
  "Nothing yet...": "Nothing yet...",
  "Notify all {{ role }} members": "Notify all {{ role }} members",
  "Offline": "Offline",
  "Ok": "Ok",
  "Online": "Online",
  "Only numbers are allowed": "Only numbers are allowed",
  "Only visible to you": "Only visible to you",
  "Open emoji picker": "Open emoji picker",
  "Open gallery at image {{ index }}": "Open gallery at image {{ index }}",
  "Open image in gallery": "Open image in gallery",
  "Open location in a map": "Open location in a map",
  "Open members actions": "Open members actions",
  "Open menu": "Open menu",
  "Option already exists": "Option already exists",
  "Option is empty": "Option is empty",
  "Options": "Options",
  "Original": "Original",
  "Owner": "Owner",
  "People matching": "People matching",
  "Photo": "Photo",
  "Photos & videos": "Photos & videos",
  "Pin": "Pin",
  "Pin a message to see it here": "Pin a message to see it here",
  "Pinned by {{ name }}": "Pinned by {{ name }}",
  "Pinned by You": "Pinned by You",
  "Pinned message": "Pinned message",
  "Pinned messages": "Pinned messages",
  "placeholder/PollComment": "Your comment",
  "placeholder/PollOptionSuggestion": "Enter a new option",
  "Play video": "Play video",
  "Playback speed {{ rate }}x": "Playback speed {{ rate }}x",
  "Poll": "Poll",
  "Poll comments": "Poll Comments",
  "Poll ended": "Poll Ended",
  "Poll options": "Poll Options",
  "Poll results": "Poll Results",
  "Previous": "Previous",
  "Previous image": "Previous image",
  "Question": "Question",
  "Question {{ optionOrderNumber}}": "Question {{ optionOrderNumber}}",
  "Question is required": "Question is required",
  "Quote Reply": "Quote Reply",
  "Reached the vote limit. Remove an existing vote first.": "Reached the vote limit. Remove an existing vote first.",
  "Recording format is not supported and cannot be reproduced": "Recording format is not supported and cannot be reproduced",
  "Remind me": "Remind me",
  "Remind Me": "Remind Me",
  "Reminder set": "Reminder set",
  "Remove": "Remove",
  "Remove {{ count }} members_one": "Remove {{ count }} member",
  "Remove {{ count }} members_other": "Remove {{ count }} members",
  "Remove {{ member }} from this channel?": "Remove {{ member }} from this channel?",
  "Remove channel members": "Remove channel members",
  "Remove reminder": "Remove reminder",
  "Remove save for later": "Remove save for later",
  "Remove user": "Remove user",
  "Removed {{ count }} members_one": "Removed {{ count }} member",
  "Removed {{ count }} members_other": "Removed {{ count }} members",
  "Replied to a thread": "Replied to a thread",
  "Reply": "Reply",
  "Reply to {{ authorName }}": "Reply to {{ authorName }}",
  "Reply to a message to start a thread": "Reply to a message to start a thread",
  "Reply to Message": "Reply to Message",
  "replyCount_one": "1 reply",
  "replyCount_other": "{{ count }} replies",
  "Resend": "Resend",
  "Retry upload": "Retry upload",
  "Review all options available in this poll": "Review all options available in this poll",
  "Review comments submitted with poll answers": "Review comments submitted with poll answers",
  "Review poll results and open an option to see detailed votes": "Review poll results and open an option to see detailed votes",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Review this message and choose whether to delete it, edit it, or send it anyway",
  "Review who voted for this option": "Review who voted for this option",
  "Save": "Save",
  "Save for later": "Save for later",
  "Saved for later": "Saved for later",
  "Search": "Search",
  "Search GIFs": "Search GIFs",
  "search-results-header-filter-source-button-label--channels": "channels",
  "search-results-header-filter-source-button-label--messages": "messages",
  "search-results-header-filter-source-button-label--users": "users",
  "Searching for {{ searchSourceType }}...": "Searching for {{ searchSourceType }}...",
  "Searching...": "Searching...",
  "searchResultsCount_one": "1 result",
  "searchResultsCount_other": "{{ count }} results",
  "Select a thread to continue the conversation": "Select a thread to continue the conversation",
  "Select more than one option": "Select More Than One Option",
  "Select one": "Select one",
  "Select one or more": "Select one or more",
  "Select up to {{count}}_one": "Select up to {{count}}",
  "Select up to {{count}}_other": "Select up to {{count}}",
  "Select your current location and optionally enable live location sharing": "Select your current location and optionally enable live location sharing",
  "Send": "Send",
  "Send a message": "Send a message",
  "Send a message to start the conversation": "Send a message to start the conversation",
  "Send Anyway": "Send Anyway",
  "Send direct message": "Send direct message",
  "Send message request failed": "Send message request failed",
  "Send poll": "Send Poll",
  "Sending...": "Sending...",
  "Sent": "Sent",
  "Share": "Share",
  "Share a file to see it here": "Share a file to see it here",
  "Share a photo or video to see it here": "Share a photo or video to see it here",
  "Share live location for": "Share live location for",
  "Share Location": "Share Location",
  "Shared live location": "Shared live location",
  "Shared location": "Shared location",
  "Shuffle": "Shuffle",
  "size limit": "size limit",
  "Slow Mode ON": "Slow Mode ON",
  "Slow mode, wait {{ seconds }}s...": "Slow mode, wait {{ seconds }}s...",
  "Some of the files will not be accepted": "Some of the files will not be accepted",
  "Start typing to search": "Start typing to search",
  "Stop sharing": "Stop sharing",
  "Submit": "Submit",
  "Suggest a new option to add to this poll": "Suggest a new option to add to this poll",
  "Suggest an option": "Suggest an Option",
  "Tap to remove": "Tap to remove",
  "Tap to remove: {{ reactionName }}": "Tap to remove: {{ reactionName }}",
  "Thinking...": "Thinking...",
  "this content could not be displayed": "this content could not be displayed",
  "This field cannot be empty or contain only spaces": "This field cannot be empty or contain only spaces",
  "This message did not meet our content guidelines": "This message did not meet our content guidelines",
  "This permanently deletes your message history with {{ user }}. This can't be undone.": "This permanently deletes your message history with {{ user }}. This can't be undone.",
  "This user will be able to message you again.": "This user will be able to message you again.",
  "This user won't be able to message you anymore. You can unblock them anytime.": "This user won't be able to message you anymore. You can unblock them anytime.",
  "Thread": "Thread",
  "Thread has not been found": "Thread has not been found",
  "Thread reply": "Thread reply",
  "Thread Reply": "Thread Reply",
  "ThreadListUnseenThreadsBanner/loading": "Loading...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} unread thread",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} unread threads",
  "Threads": "Threads",
  "timestamp/ChannelDetailPinnedMessageTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Yesterday]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/ChannelMembersLastActive": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Yesterday]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Today]\", \"nextDay\": \"[Tomorrow]\", \"lastDay\": \"[Yesterday]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[Last] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}d ago",
  "timestamp/relativeToday": "Today",
  "timestamp/relativeWeeksAgo": "{{ count }}w ago",
  "timestamp/relativeYesterday": "Yesterday",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Today] [at] HH:mm\", \"nextDay\": \"[Tomorrow] [at] HH:mm\", \"lastDay\": \"[Yesterday] [at] HH:mm\", \"nextWeek\": \"dddd [at] HH:mm\", \"lastWeek\": \"[Last] dddd [at] HH:mm\", \"sameElse\": \"ddd, D MMM [at] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "To start recording, allow the camera access in your browser",
  "To start recording, allow the microphone access in your browser": "To start recording, allow the microphone access in your browser",
  "totalVoteCount_one": "1 vote total",
  "totalVoteCount_other": "{{ count }} votes total",
  "Translated": "Translated",
  "Translated from {{ language }}": "Translated from {{ language }}",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "Type a number from 2 to 10",
  "Unarchive": "Unarchive",
  "unban-command-args": "[@username]",
  "unban-command-description": "Unban a user",
  "Unblock": "Unblock",
  "Unblock user": "Unblock user",
  "Unblock User": "Unblock User",
  "unknown error": "unknown error",
  "Unmute": "Unmute",
  "Unmute chat": "Unmute chat",
  "Unmute user": "Unmute user",
  "unmute-command-args": "[@username]",
  "unmute-command-description": "Unmute a user",
  "Unpin": "Unpin",
  "Unread messages": "Unread messages",
  "Unsupported attachment": "Unsupported attachment",
  "unsupported file type": "unsupported file type",
  "Update": "Update",
  "Update the comment attached to your poll answer": "Update the comment attached to your poll answer",
  "Update your comment": "Update Your Comment",
  "Upload blocked": "Upload blocked",
  "Upload error": "Upload error",
  "Upload failed": "Upload failed",
  "Upload Picture": "Upload Picture",
  "Upload type: \"{{ type }}\" is not allowed": "Upload type: \"{{ type }}\" is not allowed",
  "User blocked": "User blocked",
  "User muted": "User muted",
  "User removed": "User removed",
  "User unblocked": "User unblocked",
  "User unmuted": "User unmuted",
  "User uploaded content": "User uploaded content",
  "Video": "Video",
  "videoCount_one": "Video",
  "videoCount_other": "{{ count }} videos",
  "View": "View",
  "View {{count}} comments_one": "View {{count}} Comment",
  "View {{count}} comments_other": "View {{count}} Comments",
  "View all": "View all",
  "View member details for {{ member }}": "View member details for {{ member }}",
  "View original": "View original",
  "View results": "View Results",
  "View translation": "View translation",
  "Voice message": "Voice message",
  "Voice message {{ duration }}": "Voice message {{ duration }}",
  "Voice message deleted": "Voice message deleted",
  "voiceMessageCount_one": "Voice message",
  "voiceMessageCount_other": "{{ count }} voice messages",
  "Vote ended": "Vote ended",
  "Votes": "Votes",
  "Wait until all attachments have uploaded": "Wait until all attachments have uploaded",
  "Waiting for network…": "Waiting for network…",
  "You": "You",
  "You've reached the maximum number of files": "You've reached the maximum number of files"
}
